import omit from 'lodash/omit';

const IS_OPEN_SET = 'app/PromptModal/IS_OPEN_SET';

let okButtonHandler = null;
let cancelButtonHandler = null;

const initialOptions = {
  text: null,
  okButtonText: 'Submit',
  cancelButtonText: 'Cancel',
};

const initialState = {
  isOpen: false,
  options: initialOptions,
};

export {
  okButtonHandler,
  cancelButtonHandler,
};

export default function promptModalReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case IS_OPEN_SET:
      return {
        ...(payload.isOpen ? state : initialState),
        ...(payload.isOpen && {
          isOpen: payload.isOpen,
          options: {
            ...initialOptions,
            ...payload.options,
          },
        }),
      };

    default:
      return state;
  }
}

const isOpenSet = (isOpen, options = {}) => ({
  type: IS_OPEN_SET,
  payload: {
    isOpen,
    options,
  },
});

export const $modalState = state => {
  return state.PromptModal;
};

export const openModal = options => dispatch => {
  if (options.okButtonHandler) {
    okButtonHandler = options.okButtonHandler;
  }
  if (options.cancelButtonHandler) {
    cancelButtonHandler = options.cancelButtonHandler;
  }
  const stateOptions = omit(options, [
    'okButtonHandler',
    'cancelButtonHandler',
  ]);
  dispatch(isOpenSet(true, stateOptions));
  return new Promise(() => {});
};

export const closeModal = () => dispatch => {
  okButtonHandler = null;
  cancelButtonHandler = null;
  dispatch(isOpenSet(false));
};
